import { IApplicationContext } from 'shared/types/applicationContext';
import {
  // fetchUploadImage,
  TUploadImageResponse,
  IUploadImageRequest,
  createUploadImageModel,
} from 'shared/repositories/promotions-flow-control/v1/upload-image';
import { TMetaPrimitives } from '@cian/logger/shared';

// TODO: Костыль для преобразования URL изображения
// promo.cdn-cian.ru -> api.cian.ru/promotions-flow-control/v1/get-image/
function fixImageUrl(imageUrl: string | null | undefined): string | null {
  if (!imageUrl) {
    return null;
  }

  const cdnPattern = /^https:\/\/promo\.cdn-cian\.ru\/(.+)$/;
  const match = imageUrl.match(cdnPattern);

  if (match) {
    return `https://api.cian.ru/promotions-flow-control/v1/get-image/${match[1]}`;
  }

  return imageUrl;
}

type TUploadImageParameters = Omit<IUploadImageRequest, 'file'> & {
  file: File;
};

export async function uploadImage(
  { config, logger }: IApplicationContext,
  parameters: TUploadImageParameters,
): Promise<string | null> {
  try {
    const formData = new FormData();
    const arrayBuffer = await parameters.file.arrayBuffer();
    const { configId, projectId } = parameters;
    const model = createUploadImageModel({ file: arrayBuffer, configId, projectId });

    for (const name in parameters) {
      if (parameters.hasOwnProperty(name)) {
        const value = parameters[name as keyof TUploadImageParameters];
        if (value !== null) {
          formData.append(name, typeof value === 'number' ? String(value) : value);
        }
      }
    }

    const url = `${config.getStrict(`${model.microserviceName}.browserUrl`)}${model.pathApi}`;
    const options: RequestInit = {
      body: formData,
      method: model.method,
      credentials: 'include',
    };

    const response = await fetch(url, options);
    const json = await response.json();

    const result = {
      statusCode: response.status,
      response: json,
    } as TUploadImageResponse;

    // const arrayBuffer = await file.arrayBuffer();
    // const result: TUploadImageResponse = await fetchUploadImage({
    //   httpApi,
    //   parameters: {
    //     file: arrayBuffer,
    //     ...rest,
    //   },
    // });

    if (result.statusCode !== 200) {
      logger.warning(result.response.message || /* istanbul ignore next */ 'Код ответа не 200', {
        domain: 'src/shared/services/uploadImage.ts [uploadImage]',
        message: 'Не удалось загрузить изображение',
        errors: result.response.errors as unknown as TMetaPrimitives[],
      });

      return null;
    }

    return fixImageUrl(result.response.imageUrl);
  } catch (ex) {
    logger.error(ex, {
      domain: 'src/shared/services/uploadImage.ts [uploadImage]',
      message: 'Не удалось загрузить изображение',
    });

    return null;
  }
}
